// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.contractContainer.preContractual.';

const CHANGE_IBAN = `${DOMAIN}changeIban`,
  EVERY_MONTH_INSTALLMENTS = `${DOMAIN}everyMonthInstallments`,
  INFORMATION_TITLE = `${DOMAIN}financialTitle`;

export { CHANGE_IBAN, EVERY_MONTH_INSTALLMENTS, INFORMATION_TITLE };
